import { useNavigate } from '@web/Router/router.hooks';
import { useConversationState } from '@web/conversations/Conversation/ConversationProvider/ConversationProvider';
import { useArchiveConversationAction } from '@web/conversations/Conversation/ConversationProvider/hooks/useArchiveConversationAction';

export const useArchiveConversationModal = () => {
  const navigate = useNavigate();
  const { id } = useConversationState();
  const { action } = useArchiveConversationAction();

  const onSubmit = async () => {
    await action({ id });
    navigate.toConversationRoot();
  };

  return {
    onSubmit,
  };
};
